export default "__VITE_ASSET__Dlj0AFg1__"